import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import FacilityListContainer from "./FacilityListContainer";

const FacilityListRouteContainer = ({ history, location }) => (
  <FacilityListContainer history={history} location={location} />
);

FacilityListRouteContainer.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(FacilityListRouteContainer);
